import { useCallback } from "react";
import { apolloClient } from "@td/ui";
import ADMINS_SEARCH_QUERY from "../queries/admins-search.graphql";
import { map } from "lodash";

const useAdminsSearch = () => {
  const loadAdmins = useCallback(async (params, limit = 10) => {
    try {
      const { data } = await apolloClient.query({
        query: ADMINS_SEARCH_QUERY,
        variables: {
          params,
          first: limit,
        },
        fetchPolicy: "network-only",
      });

      return map(data.adminBasicSearch.edges, "node");
    } catch (e) {
      return null;
    }
  }, [apolloClient]);

  return {
    loadAdmins,
  };
};

export default useAdminsSearch;
